import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  style: {
    "margin-left": "0px",
    "display": "flex"
  }
};
const _hoisted_2 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  style: {
    "color": "#ff34c6"
  }
};
const _hoisted_5 = {
  style: {
    "float": "left"
  }
};
const _hoisted_6 = {
  style: {
    "float": "right",
    "color": "#8492a6",
    "font-size": "13px"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_10 = {
  class: "dialog-footer"
};
const _hoisted_11 = {
  style: {
    "float": "left"
  }
};
const _hoisted_12 = {
  style: {
    "float": "right",
    "color": "#8492a6",
    "font-size": "13px"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      width: "150px",
      style: {
        "margin-top": "-30px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_select, {
        modelValue: $data.selectvalue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectvalue = $event),
        placeholder: "全部",
        clearable: "handleNodeClick",
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.treeData, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.selectvalue,
            label: item.roleName,
            value: item.roleId,
            onClick: $options.handleNodeClick
          }, null, 8, ["label", "value", "onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])]),
      _: 1
    }), _createVNode(_component_el_main, {
      style: {
        "margin-top": "-50px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
        style: {
          "width": "15%"
        },
        modelValue: $data.shuru,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.shuru = $event),
        placeholder: "请输入用户名",
        clearable: ""
      }, null, 8, ["modelValue"]), _cache[37] || (_cache[37] = _createTextVNode("     ", -1)), _createVNode(_component_el_button, {
        onClick: $options.select,
        type: "primary",
        plain: ""
      }, {
        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("搜索", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: $options.chaxun,
        type: "primary",
        plain: ""
      }, {
        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("刷新", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.xinjian,
        plain: ""
      }, {
        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("新建用户", -1)]))]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
        data: $data.tablee,
        modelValue: $data.dialogVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialogVisible = $event),
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "userName",
          label: "登录名",
          style: {
            "width": "auto"
          },
          "min-width": "80"
        }), _createVNode(_component_el_table_column, {
          prop: "userAlias",
          label: "姓名",
          style: {
            "width": "auto"
          },
          "min-width": "80"
        }), _createVNode(_component_el_table_column, {
          prop: "roleName",
          label: "角色",
          style: {
            "width": "auto"
          },
          "min-width": "80"
        }), _createVNode(_component_el_table_column, {
          prop: "userlock",
          label: "账号状态",
          style: {
            "width": "auto"
          },
          "min-width": "100"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.userlock,
            "onUpdate:modelValue": $event => scope.row.userlock = $event,
            "active-text": "激活",
            "inactive-text": "锁定",
            "active-color": "#13ce66",
            "active-value": 0,
            "inactive-value": 1,
            "inactive-color": "#ff4949",
            onChange: $event => $options.changeSwitch(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "capIndex",
          label: "是否已分配头盔",
          style: {
            "width": "auto"
          },
          "min-width": "80"
        }, {
          default: _withCtx(scope => [scope.row.capIndex == null || scope.row.capIndex == '' || scope.row.capIndex == ' ' ? (_openBlock(), _createElementBlock("span", _hoisted_3, "未分配")) : _createCommentVNode("", true), scope.row.capIndex != null && scope.row.capIndex !== '' && scope.row.capIndex != ' ' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已分配")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "authorityId",
          label: "操作",
          "min-width": "60",
          style: {
            "width": "auto"
          }
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: $event => $options.update(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "modelValue"])]), _createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => $data.pageSize = $event),
        "page-sizes": [10, 20],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"]), _createElementVNode("div", null, [_createVNode(_component_el_dialog, {
        modelValue: $data.dialogFormVisible,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.dialogFormVisible = $event),
        title: "添加用户",
        "lock-scroll": false,
        width: "80%",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_10, [_createVNode(_component_el_button, {
          style: {
            "margin-top": "-50px"
          },
          onClick: _cache[17] || (_cache[17] = $event => $data.dialogFormVisible = false)
        }, {
          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("关闭", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          style: {
            "margin-top": "-50px"
          },
          type: "primary",
          onClick: _cache[18] || (_cache[18] = $event => $options.onSubmit('form')),
          disabled: $data.disabled
        }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("确定", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.form,
          ref: "form",
          rules: $data.rules,
          "status-icon": "",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "登录名",
            required: "",
            prop: "userName",
            style: {
              "float": "left"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.userName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.userName = $event),
              placeholder: "请输入登录名",
              style: {
                "width": "300px"
              },
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              required: ""
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.form.authorityId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.authorityId = $event),
              type: "hidden"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "姓名",
            required: "",
            prop: "userAlias"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.userAlias,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.userAlias = $event),
              placeholder: "请输入姓名",
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              style: {
                "width": "300px"
              },
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              required: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码",
            required: "",
            prop: "passWord",
            style: {
              "float": "left"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.passWord,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.passWord = $event),
              placeholder: "请输入密码",
              onkeyup: "this.value=this.value.replace(/[, ]/g,'')",
              style: {
                "width": "300px"
              },
              clearable: "",
              autocomplete: "off",
              "show-word-limit": "",
              required: ""
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.form.roleId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.roleId = $event),
              style: {
                "width": "50%"
              },
              type: "hidden"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.form.areaId,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.areaId = $event),
              style: {
                "width": "50%"
              },
              type: "hidden"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
              modelValue: $data.form.createBy,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.form.createBy = $event),
              style: {
                "width": "50%"
              },
              type: "hidden"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.form.phone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.phone = $event),
              placeholder: "请输入手机号",
              onkeyup: "this.value=this.value.replace(/[,]/g,'')",
              style: {
                "width": "300px"
              },
              clearable: "",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_container, null, {
            default: _withCtx(() => [_createVNode(_component_el_aside, {
              style: {
                "width": "330px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.selectvalue2,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.selectvalue2 = $event),
                  placeholder: "请选择角色",
                  clearable: "handleNodeClick",
                  filterable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.treeData, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.roleId,
                      label: item.roleName,
                      value: item.roleId,
                      onClick: $options.handleCheckChange
                    }, null, 8, ["label", "value", "onClick"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "工具箱",
                style: {
                  "float": "left"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.toolBoxSelect,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.toolBoxSelect = $event),
                  placeholder: "请选择工具箱",
                  clearable: "handleNodeClick"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toolBox, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.toolId,
                      label: item.toolName,
                      value: item.toolId
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "安全帽",
                style: {
                  "float": "left"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.capsSelect,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.capsSelect = $event),
                  placeholder: "请选择安全帽",
                  clearable: "handleNodeClick",
                  filterable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.caps, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.capIndex,
                      label: item.localName,
                      value: item.capIndex
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_row, null, {
                        default: _withCtx(() => [_createVNode(_component_el_col, {
                          span: 12
                        }, {
                          default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(item.capIndex + ":" + "   "), 1)]),
                          _: 2
                        }, 1024), _createVNode(_component_el_col, {
                          span: 12
                        }, {
                          default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(item.localName), 1)]),
                          _: 2
                        }, 1024)]),
                        _: 2
                      }, 1024)]),
                      _: 2
                    }, 1032, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "管理区域",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: $data.casvalue,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.casvalue = $event),
              options: $data.AreaData,
              placeholder: "区域信息",
              ref: "cascaderAddr",
              props: $data.setKesLabel,
              "show-all-levels": false,
              onChange: $options.areaCheckChange
            }, {
              default: _withCtx(({
                node,
                data
              }) => [_createElementVNode("span", null, _toDisplayString(data.areaName), 1), !node.isLeaf ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(data.children.length) + ") ", 1)) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["modelValue", "options", "props", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上传签名",
            "status-icon": "",
            "label-width": "160px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: this.ip + '/user/saveSign',
              "show-file-list": false,
              "on-success": $options.uploadSuccess,
              "before-upload": $options.beforeAvatarUpload,
              "on-preview": $options.handlePictureCardPreview,
              ref: "upload"
            }, {
              default: _withCtx(() => [$data.imageUrl ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $data.imageUrl,
                class: "avatar"
              }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("i", _hoisted_9))]),
              _: 1
            }, 8, ["action", "on-success", "before-upload", "on-preview"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_dialog, {
        title: "编辑用户",
        width: "80%",
        modelValue: $data.dialogVisible,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.dialogVisible = $event),
        "before-close": $options.cancel,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
          style: {
            "margin-top": "20px"
          },
          onClick: $options.cancel
        }, {
          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("关闭", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "margin-top": "20px"
          },
          type: "primary",
          onClick: _cache[32] || (_cache[32] = $event => $options.editSubmit('editform')),
          disabled: $data.disabled
        }, {
          default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode("确定", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "editform",
          model: $data.editform,
          rules: $data.rules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户名",
            "status-icon": "",
            "label-width": "160px",
            prop: "userName",
            style: {
              "float": "left"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.userName,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.editform.userName = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "姓名",
            "status-icon": "",
            "label-width": "160px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.editform.userAlias,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.editform.userAlias = $event),
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_container, null, {
            default: _withCtx(() => [_createVNode(_component_el_aside, {
              style: {
                "margin-left": "80px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.selectvalue2,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.selectvalue2 = $event),
                  placeholder: "请选择角色",
                  clearable: "handleNodeClick",
                  filterable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.treeData, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.roleId,
                      label: item.roleName,
                      value: item.roleId,
                      onClick: $options.handleCheckChange
                    }, null, 8, ["label", "value", "onClick"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "密码",
                prop: "passWord"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.passWord,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.editform.passWord = $event),
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "工具箱"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.toolBoxSelectUpdate,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.toolBoxSelectUpdate = $event),
                  placeholder: "请选择工具箱",
                  clearable: "handleNodeClick"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.toolBox, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.toolId,
                      label: item.toolName,
                      value: item.toolId
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "安全帽"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: $data.capsSelectUpdate,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.capsSelectUpdate = $event),
                  placeholder: "请选择安全帽",
                  clearable: "handleNodeClick",
                  onClick: $options.getCaps
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.caps, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.capIndex,
                      label: item.localName,
                      value: item.capIndex
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_row, null, {
                        default: _withCtx(() => [_createVNode(_component_el_col, {
                          span: 12
                        }, {
                          default: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(item.capIndex + ":"), 1)]),
                          _: 2
                        }, 1024), _createVNode(_component_el_col, {
                          span: 12
                        }, {
                          default: _withCtx(() => [_createElementVNode("span", _hoisted_12, _toDisplayString(item.localName), 1)]),
                          _: 2
                        }, 1024)]),
                        _: 2
                      }, 1024)]),
                      _: 2
                    }, 1032, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onClick"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "passWord"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.phone,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.editform.phone = $event),
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "现存签名",
                style: {
                  "margin-top": "30px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_image, {
                  class: "avatar",
                  src: $data.url,
                  modelValue: $data.editform.userSign,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.editform.userSign = $event)
                }, null, 8, ["src", "modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "选择签名",
                style: {
                  "margin-top": "20px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: this.ip + '/user/saveSign',
                  "show-file-list": false,
                  "on-success": $options.handleAvatarSuccess,
                  "before-upload": $options.beforeAvatarUpload,
                  "on-preview": $options.handlePictureCardPreview,
                  ref: "upload"
                }, {
                  default: _withCtx(() => [$data.imageUrl ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $data.imageUrl,
                    class: "avatar"
                  }, null, 8, _hoisted_13)) : (_openBlock(), _createElementBlock("i", _hoisted_14))]),
                  _: 1
                }, 8, ["action", "on-success", "before-upload", "on-preview"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_main, {
              style: {
                "margin-left": "140px",
                "margin-top": "-20px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管理区域"
              }, {
                default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_cascader, {
                  modelValue: $data.casvalue,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.casvalue = $event),
                  options: $data.AreaData,
                  placeholder: "区域信息",
                  ref: "cascaderAddr",
                  props: $data.setKesLabel,
                  key: $data.modalKey,
                  "show-all-levels": false,
                  onChange: $options.areaCheckChange
                }, {
                  default: _withCtx(({
                    node,
                    data
                  }) => [_createElementVNode("span", null, _toDisplayString(data.areaName), 1), !node.isLeaf ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(data.children.length) + ") ", 1)) : _createCommentVNode("", true)]),
                  _: 1
                }, 8, ["modelValue", "options", "props", "onChange"])), _createVNode(_component_el_input, {
                  modelValue: $data.editform.areaId,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.editform.areaId = $event),
                  style: {
                    "width": "50%"
                  },
                  type: "hidden"
                }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
                  modelValue: $data.editform.createBy,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.editform.createBy = $event),
                  style: {
                    "width": "50%"
                  },
                  type: "hidden"
                }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
                  modelValue: $data.editform.updateBy,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.editform.updateBy = $event),
                  style: {
                    "width": "50%"
                  },
                  type: "hidden"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "before-close"])]), _cache[43] || (_cache[43] = _createElementVNode("div", null, null, -1))]),
      _: 1
    })]),
    _: 1
  });
}